import React, { useState } from 'react';
import axios from 'axios';

const LeadMagnet = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Execute reCAPTCHA
      const token = await window.grecaptcha.execute('6Lc7qUcsAAAAAIYrbbGallNI_umfuVJT9qNd-C50', { action: 'lead_magnet' });
      
      await axios.post('/api/lead-magnet', { 
        email, 
        name, 
        recaptchaToken: token 
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const prompts = [
    "The moment I knew you were 'the one'...",
    "What I love most about our everyday life together...",
    "The qualities I admire most in you...",
    "How you've helped me grow as a person...",
    "My favorite memory of us together...",
    "The promises I want to make for our future...",
    "What 'home' means when I'm with you...",
    "The little things you do that make me fall in love again...",
    "How I want to support you through life's challenges...",
    "My dreams for us in 10, 20, 50 years..."
  ];

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          
          {/* Hero Section */}
          <div className="glass-card text-center mb-5">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>💕</div>
            <h1 className="commercial-heading mb-3" style={{ fontSize: '2.5rem' }}>
              Free: 10 Wedding Vow Prompts
            </h1>
            <p className="lead" style={{ color: '#5d3a3b', fontSize: '1.3rem', maxWidth: '700px', margin: '0 auto 1.5rem' }}>
              Get your creative juices flowing with our curated prompts to help you write heartfelt, 
              personal wedding vows that will move your partner to tears.
            </p>
            
            {/* Social Sharing Buttons */}
            <div className="d-flex gap-2 flex-wrap justify-content-center">
              <span style={{ color: '#5d3a3b', fontWeight: '500', marginRight: '0.5rem', alignSelf: 'center' }}>Share with engaged friends:</span>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://vowauthor.com/free-vow-prompts')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(59, 89, 152, 0.1)',
                  color: '#3b5998',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                title="Share on Facebook"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent('https://vowauthor.com/free-vow-prompts')}&text=${encodeURIComponent('Free wedding vow prompts to help you write the perfect vows! 💕')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(29, 161, 242, 0.1)',
                  color: '#1da1f2',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                title="Share on Twitter"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent('https://vowauthor.com/free-vow-prompts')}&description=${encodeURIComponent('Free: 10 Wedding Vow Prompts - Get inspired to write heartfelt vows!')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(189, 8, 28, 0.1)',
                  color: '#bd081c',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                title="Pin on Pinterest"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
                </svg>
              </a>
              <button
                onClick={() => {
                  navigator.clipboard.writeText('https://vowauthor.com/free-vow-prompts');
                  alert('Link copied to clipboard!');
                }}
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(30, 58, 95, 0.1)',
                  color: '#1e3a5f',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                title="Copy link"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="row">
            {/* Preview Column */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="glass-card h-100">
                <h2 style={{ 
                  color: '#1e3a5f', 
                  fontSize: '1.5rem',
                  marginBottom: '1.5rem',
                  fontFamily: 'Playfair Display, Georgia, serif'
                }}>
                  What's Inside:
                </h2>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {prompts.map((prompt, index) => (
                    <li 
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        marginBottom: '1rem',
                        color: '#4a3728',
                        fontSize: '1rem',
                        lineHeight: '1.5'
                      }}
                    >
                      <span style={{
                        color: '#f472b6',
                        fontWeight: 'bold',
                        minWidth: '24px'
                      }}>
                        {index + 1}.
                      </span>
                      <span style={{ fontStyle: 'italic' }}>{prompt}</span>
                    </li>
                  ))}
                </ul>
                <div style={{
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: 'rgba(244, 114, 182, 0.1)',
                  borderRadius: '12px',
                  textAlign: 'center'
                }}>
                  <p style={{ color: '#5d3a3b', marginBottom: '0', fontSize: '0.95rem' }}>
                    <strong>PLUS:</strong> Bonus tips on vow structure, length, and delivery!
                  </p>
                </div>
              </div>
            </div>

            {/* Form Column */}
            <div className="col-lg-6">
              <div className="glass-card h-100">
                {success ? (
                  <div className="text-center py-5">
                    <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✨</div>
                    <h2 style={{ color: '#1e3a5f', marginBottom: '1rem' }}>Check Your Email!</h2>
                    <p style={{ color: '#5d3a3b', fontSize: '1.1rem' }}>
                      Your free wedding vow prompts PDF is on its way to <strong>{email}</strong>
                    </p>
                    <p style={{ color: '#8b5a5b', fontSize: '0.95rem', marginTop: '1.5rem' }}>
                      Didn't receive it? Check your spam folder or{' '}
                      <button 
                        onClick={() => { setSuccess(false); setEmail(''); setName(''); }}
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          color: '#f472b6', 
                          textDecoration: 'underline',
                          cursor: 'pointer' 
                        }}
                      >
                        try again
                      </button>
                    </p>
                    <hr style={{ margin: '2rem 0', borderColor: 'rgba(30, 58, 95, 0.2)' }} />
                    <p style={{ color: '#5d3a3b' }}>
                      Ready to create your personalized vows?
                    </p>
                    <a href="/" className="btn btn-primary btn-lg">
                      Get Started - $9.99
                    </a>
                  </div>
                ) : (
                  <>
                    <h2 style={{ 
                      color: '#1e3a5f', 
                      fontSize: '1.5rem',
                      marginBottom: '0.5rem',
                      fontFamily: 'Playfair Display, Georgia, serif'
                    }}>
                      Get Your Free PDF
                    </h2>
                    <p style={{ color: '#8b5a5b', marginBottom: '1.5rem' }}>
                      Enter your details below and we'll send it right over!
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: '#5d3a3b', fontWeight: '500' }}>
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Your first name"
                          required
                          style={{
                            borderRadius: '12px',
                            padding: '0.75rem 1rem',
                            border: '2px solid rgba(30, 58, 95, 0.2)'
                          }}
                        />
                      </div>
                      
                      <div className="mb-4">
                        <label className="form-label" style={{ color: '#5d3a3b', fontWeight: '500' }}>
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="your@email.com"
                          required
                          style={{
                            borderRadius: '12px',
                            padding: '0.75rem 1rem',
                            border: '2px solid rgba(30, 58, 95, 0.2)'
                          }}
                        />
                      </div>

                      {error && (
                        <div className="alert alert-danger mb-3" style={{ borderRadius: '12px' }}>
                          {error}
                        </div>
                      )}

                      <button 
                        type="submit" 
                        className="btn btn-primary btn-lg w-100"
                        disabled={loading}
                        style={{ padding: '0.875rem' }}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-download me-2"></i>
                            Send My Free Prompts
                          </>
                        )}
                      </button>
                    </form>

                    <div style={{ 
                      marginTop: '1.5rem', 
                      padding: '1rem',
                      background: 'rgba(30, 58, 95, 0.05)',
                      borderRadius: '12px',
                      textAlign: 'center'
                    }}>
                      <p style={{ color: '#8b5a5b', fontSize: '0.85rem', marginBottom: 0 }}>
                        🔒 We respect your privacy. Unsubscribe anytime.
                      </p>
                    </div>

                    <div className="text-center mt-4">
                      <p style={{ color: '#8b5a5b', fontSize: '0.9rem' }}>
                        Already have prompts?{' '}
                        <a href="/" style={{ color: '#f472b6', textDecoration: 'none' }}>
                          Create your vows now →
                        </a>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="glass-card text-center mt-4">
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
              <p style={{ 
                color: '#4a3728', 
                fontSize: '1.2rem', 
                fontStyle: 'italic',
                lineHeight: '1.7'
              }}>
                "These prompts helped me organize my thoughts and find the perfect words. 
                I was stressing about my vows for weeks, but this PDF made it so much easier!"
              </p>
              <p style={{ color: '#8b5a5b', marginTop: '1rem' }}>
                <strong>— Sarah M., Bride</strong>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LeadMagnet;


